// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3St2A","question":"styles_question__3hxs-","description":"styles_description__2rDzf"};